module.exports = __webpack_public_path__ + "static/media/layout-1.28068e57.jpg";